import React from 'react';

export function SuccessCriteriaLegend({ variant = 'panel' }) {
  const rootClass = variant === 'modal' ? 'ci-sc-legend' : 'ci-status-legend';
  return (
    <div className={rootClass}>
      <span className="ci-legend-item">
        <span className="ci-legend-dot ci-satisfied-dot" /> Satisfied
      </span>
      <span className="ci-legend-item">
        <span className="ci-legend-dot ci-not-satisfied-dot" /> Not satisfied
      </span>
      <span className="ci-legend-item">
        <span className="ci-legend-dot ci-partially-dot" /> Partially satisfied
      </span>
    </div>
  );
}
